import { countRemittances, createRemittance, getRemittances, updateRemittance } from '../../../utils'

export { countRemittances, createRemittance, getRemittances, updateRemittance }

export default {
  countRemittances,
  createRemittance,
  getRemittances,
  updateRemittance
}
